import { render, staticRenderFns } from "./vuex-pagination.vue?vue&type=template&id=167eb764&"
import script from "./vuex-pagination.vue?vue&type=script&lang=js&"
export * from "./vuex-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/domains/b2b/htdocs/local/templates/b2bmodern_default/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167eb764')) {
      api.createRecord('167eb764', component.options)
    } else {
      api.reload('167eb764', component.options)
    }
    module.hot.accept("./vuex-pagination.vue?vue&type=template&id=167eb764&", function () {
      api.rerender('167eb764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/vuex-pagination.vue"
export default component.exports